export const BACKGROUND_COLOR = '#f5f2ec';
export const WEDGE_STROKE = '#0e2232';
export const STROKE_COLOR = '#132b3a';
export const BRUSH_SIZE = { min: 2, max: 10, step: 0.5, default: 2.5 };
export const BLOOM_DURATION = 420; // ms
export const MAX_STROKES = 5;
export const SAVE_LIMIT = 12;

export const foldPresets = [
  { id: '6', value: 6, labelKey: 'folds.six' },
  { id: '8', value: 8, labelKey: 'folds.eight' },
  { id: '12', value: 12, labelKey: 'folds.twelve' },
];
